<template>
  <div class="card">
    <div class="left">
      <div class="add" @click="addArea()" v-show="$ButtonShow('YPA_ADD_01')">新增分区</div>
      <div class="area" v-for="(item, index) in areaList" :key="index" @click="selectArea(index)">
        <el-tooltip class="item" effect="dark" :content="item.areaName" placement="top"
          v-if="item.areaName.length > 10">
          <div class="name" :class="{ active: currentIndex === index }">
            {{ item.areaName }}
          </div>
        </el-tooltip>
        <div class="name" :class="{ active: currentIndex === index }" v-else>
          {{ item.areaName }}
        </div>
        <i class="el-icon-edit icon" @click="updateArea(item.projectAreaId)" v-show="$ButtonShow('YPA_EDT_01')"></i>
        <i class="el-icon-delete-solid icon" @click="deleteArea(item.projectAreaId)"
          v-show="$ButtonShow('YPA_DEL_01')"></i>
      </div>
      <img v-if="areaList.length === 0" src="@/assets/img/irrigation/nodata.png">
    </div>

    <div class="right">
      <div class="area" v-if="areaList.length > 0">分区面积(㎡) <span>{{ areaList[currentIndex].areaAcreage || '0' }}</span>
      </div>
      <div style="height: 100%;" id="mapContainer"></div>
    </div>
  </div>
</template>

<script>
import { drawPolygon } from '@/utils/formatData'
const polygonCurrentStyle = {
  strokeColor: '#3592FE',
  fillColor: '#3592FE',
  strokeWeight: 4,
  strokeOpacity: 1,
  fillOpacity: 0.3,
  strokeStyle: 'solid',
  zIndex: 100
}
export default {
  name: 'List',
  components: {
  },
  data() {
    return {
      tableData: [],
      areaList: [],
      currentIndex: 0,
      map: null,
      ploygons: []
    }
  },
  computed: {
    projectId() {
      return this.$route.query.projectId
    }
  },
  created() {
    !this.map && this.loadMap().then(() => {
      this.getAreaList()
    })
  },
  destroyed() {
    if (this.map) {
      this.map.destroy()
    }
  },
  methods: {
    // 获取区域
    getAreaList() {
      this.$axios.get(this.$apis.project.selectYhProjectAreaByList, {
        projectId: this.projectId
      }).then(res => {
        this.areaList = res || []
        this.areaList.length > 0 && this.selectArea(0)
      })
    },
    // 选中区域
    selectArea(index) {
      this.currentIndex = index
      this.map && this.map.remove(this.ploygons)
      this.getDetail()
    },
    // 区域详情
    getDetail() {
      this.$axios.get(this.$apis.project.selectYhProjectAreaByProjectAreaId, {
        projectAreaId: this.areaList[this.currentIndex].projectAreaId
      }).then((res) => {
        if (this.map) {
          // 区域
          this.ploygons = drawPolygon(this.map, res.locationList, polygonCurrentStyle, null)
          this.map.setZoom(14)
        }
      })
    },
    // 地图初始化
    loadMap() {
      const map = new AMap.Map('mapContainer', {
        zoom: 11
      })
      this.map = map
      return this.map
    },
    addArea() {
      this.$router.push({
        path: '/projectList/detail/subzone/add',
        query: {
          projectId: this.projectId
        }
      })
    },
    updateArea(areaId) {
      this.$router.push({
        path: '/projectList/detail/subzone/add',
        query: {
          projectId: this.projectId,
          areaId: areaId
        }
      })
    },
    deleteArea(areaId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.project.deleteYhProjectArea, {
          projectAreaId: areaId
        }).then(() => {
          this.currentIndex = 0
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.map && this.map.remove(this.ploygons)
          this.getAreaList()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  display: flex;
  position: relative;
  height: calc(100% - 60px);
}

#mapContainer {
  height: 100%;
}

.tips {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 199;
  width: 140px;
  height: auto;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(57, 52, 167, 0.2);
  border-radius: 20px;
}

.left {
  width: 300px;
  min-width: 300px;
  height: 100%;
  background: #F6F8FB;
  box-shadow: 0px 1px 2px 0px rgba(139, 172, 237, 0.1);
  border-radius: 10px;
  padding: 25px 25px 25px 16px;
  margin: 0 20px 0 0;

  .area {
    display: flex;
    position: relative;

    .icon {
      position: absolute;
      color: var(--color-primary);
      top: 12px;
      display: none;
      cursor: pointer;
    }

    .el-icon-edit {
      right: 25px;
    }

    .el-icon-delete-solid {
      right: 5px;
    }

    &:hover {
      .icon {
        display: block;
      }
    }
  }

  .name,
  .add {
    align-items: center;
    width: 200px;
    font-size: 14px;
    height: 0;
    line-height: 0;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000517;
    margin-bottom: 10px;
    cursor: pointer;
    padding: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.active,
    &:hover {
      background: var(--color-primary);
      box-shadow: 0px 2px 4px 0px #E5E4FF;
      border-radius: 20px;
      color: #FFFFFF;
    }
  }
}

.right {
  position: relative;
  flex: 1;
  border-left: 1px solid #F4F4F4;
  padding: 20px 0 20px 20px;

  .area {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 40px;
    top: 40px;
    padding: 6px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    min-width: 120px;
    height: 150px;
    background: #FCFCFC;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.3);
    border-radius: 9px;
    z-index: 9999;

    span {
      font-size: 60px;
      font-family: DINCondensed-Bold, DINCondensed;
      font-weight: bold;
      color: #4A4A4A;
      margin-top: 20px;
      text-align: center;
    }
  }
}
</style>
